// Utils
import { headOfPath, joinPaths, setIn, tailOfPath } from 'ezyvet-fe-helpers';
import { createObjectPaths } from '../../objectIdentity';
import { resolveObjectIdsToCurrentValue } from './resolveObjectIdsToCurrentValue';
/**
 * To the given object `values` apply the given list property update changes.
 *
 * @template T extends object
 * @param {T} values
 * @param {ChangeList} changes
 * @param {IndexedStore<object>} newObjects
 * @param {PropertyPathCheck} [isMergeableCheck = undefined]
 *
 * @return {T}
 */
export var applyPropertyValueChanges = function (values, changes, newObjects) {
    var newValues = values;
    var objectPaths = createObjectPaths(newValues);
    Object.keys(changes).forEach(function (changePath) {
        var objectId = headOfPath(changePath);
        var property = tailOfPath(changePath);
        var objectPath = objectPaths[objectId];
        if (objectPath === undefined) {
            // nothing to do the object with the property has since been deleted
            return;
        }
        var propertyTarget = joinPaths(objectPath, property);
        var _a = changes[changePath], newValue = _a[1];
        newValue = resolveObjectIdsToCurrentValue(newValue, newValues, newObjects);
        newValues = setIn(newValues, propertyTarget, newValue);
    });
    return newValues;
};
//# sourceMappingURL=applyPropertyValueChanges.js.map